import { Component, OnInit } from '@angular/core';
import { AssetGroupService } from '../asset-group.service';
import { PartnershipDataGroup, RelationshipDataGroup } from '../models/UserRelationship';
import { Subscription } from 'rxjs';
import { ConfirmationService, Message } from 'primeng/api';
import { GlobalService } from '../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';

@Component({
  selector: 'app-manage-asset-group',
  templateUrl: './manage-asset-group.component.html',
  styleUrls: ['./manage-asset-group.component.scss'],
  providers: [ConfirmationService]
})
export class ManageAssetGroupComponent implements OnInit {

  loading = false;
  subscription: Subscription;
  messages: Message[] = [];
  displayAddDialog = false;
  displayEditDialog = false;
  partnershipDataGroup: PartnershipDataGroup[];
  partnershipDataGroupList = <any>[];
  partnershipWithMasterGroup = [];
  partnershipDataGroupSelected: PartnershipDataGroup;
  showAddButton: boolean;
  rows = 10;
  rowsPerPageOptions = [10, 25, 50, 100];
  paginator = true;

  constructor(private assetGroupSvc: AssetGroupService,
              private confirmationService: ConfirmationService,
              private _global: GlobalService) { }

  ngOnInit() {
    this.loading = true;
    this.subscription = this.assetGroupSvc.findMasterByPerson()
      .subscribe((assetData: any) => {
        this.partnershipDataGroup = <PartnershipDataGroup[]>assetData.data;
        this.partnershipDataGroupList = <any>[];
        this.partnershipDataGroup.map((dataGroup: PartnershipDataGroup, index) => {
            if (!dataGroup.RelationshipDataGroup.IsMasterList) {
              const partnerDataGroup = this.populatePartnerDataGroup(dataGroup);
              this.partnershipDataGroupList.push(partnerDataGroup);
            } else {
              this.partnershipWithMasterGroup.push(dataGroup.RelationshipDataGroup.RelationshipId);
            }
            this.loading = false;
            this.showAddButton = this.partnershipWithMasterGroup.length > 0 ? true : false;
          });
      });
  }

  private populatePartnerDataGroup(dataGroup: PartnershipDataGroup): any {
    const partnerDataGroup = <any>{};
    partnerDataGroup.RelationshipDataGroup = dataGroup.RelationshipDataGroup;
    partnerDataGroup.Company = dataGroup.Company;
    partnerDataGroup.AssetIdList = [];
    if (dataGroup.RelationshipDataGroup.Items) {
      for ( let i = 0; i < dataGroup.RelationshipDataGroup.Items.length; i++ ) {
        partnerDataGroup.AssetIdList.push(dataGroup.RelationshipDataGroup.Items[i].ItemId);
      }
    }
    partnerDataGroup.UserCount = 0;
    if (dataGroup.RelationshipDataGroup.Assigned) {
      partnerDataGroup.UserCount = dataGroup.RelationshipDataGroup.Assigned.length;
    }
    return partnerDataGroup;
  }

  edit(partnershipDataGroup: PartnershipDataGroup): void {
    this.displayEditDialog = true;
    this.partnershipDataGroupSelected = partnershipDataGroup;
  }

  onAdd(partnershipDataGroup: PartnershipDataGroup) {
    const partnerDataGroup = this.populatePartnerDataGroup(partnershipDataGroup);
    this.partnershipDataGroupList.unshift(partnerDataGroup);
  }

  onEdit(partnershipDataGroup: PartnershipDataGroup) {
    const partnerDataGroup = this.populatePartnerDataGroup(partnershipDataGroup);
    this.partnershipDataGroupList[this.partnershipDataGroupList.indexOf(this.partnershipDataGroupSelected)] = partnerDataGroup;
  }

  delete(partnershipDataGroup: PartnershipDataGroup): void {
      // tslint:disable-next-line:max-line-length
    const message = `Are you sure you want to remove the Asset Group: ${partnershipDataGroup.RelationshipDataGroup.RelationshipGroupName}.`;
    this.confirmationService.confirm({
      message: message,
      accept: () => {
        this.loading = true;
        this.messages = [{severity: 'info', summary: 'Processing Delete', detail: ''}];
        this.subscription = this.assetGroupSvc.remove(partnershipDataGroup.RelationshipDataGroup.RelationshipGroupId)
        .subscribe(assetData => {
          this.loading = false;
          const index = this.partnershipDataGroupList.indexOf(partnershipDataGroup);
          this.partnershipDataGroupList = this.partnershipDataGroupList.filter((dataGroup: PartnershipDataGroup, i) => i !== index);
          this.messages = [{severity: 'info', summary: 'Deleted: ',
          detail: `Successfully Deleted Asset Group ${partnershipDataGroup.RelationshipDataGroup.RelationshipGroupName}.`}];
        });
      }
    });
  }

  showAddDialog(): void {
    this.displayAddDialog = true;
  }

  addDialogHide(display: boolean): void {
    this.displayAddDialog = display;
  }

  editDialogHide(display: boolean): void {
    this.displayEditDialog = display;
  }

  displayAssetIds(op, event, group) {
    this.partnershipDataGroupSelected = group;
    op.show(event);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
